import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import ContentSection from './components/ContentSection';
import ArticleTeaser from './components/ArticleTeaser';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import FooterSection from './components/FooterSection';
import { SITE_URL } from '@/constants/site';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@graph': [
                {
                  '@type': 'WebSite',
                  name: 'VigorBuy Spreadsheet',
                  url: SITE_URL,
                  description: 'Complete VigorBuy Spreadsheet buying guide with product resources, safety tips, and tutorials.',
                  potentialAction: {
                    '@type': 'SearchAction',
                    target: `${SITE_URL}/search?q={search_term_string}`,
                    'query-input': 'required name=search_term_string',
                  },
                },
                {
                  '@type': 'WebPage',
                  name: 'VigorBuy Spreadsheet – Complete Buying Guide',
                  description: 'Discover the latest VigorBuy Spreadsheet guides, product resources, safety tips, and buying tutorials.',
                  url: SITE_URL,
                  mainEntity: {
                    '@type': 'Organization',
                    name: 'VigorBuy',
                    url: SITE_URL,
                  },
                },
              ],
            }),
          }}
        />
        <HeroSection />
        <CategorySection />
        <ContentSection />
        <ArticleTeaser />
        <FAQSection />
        <CTASection />
      </main>
      <FooterSection />
    </div>
  );
}